import { createFileRoute } from "@tanstack/react-router";
import { kennelClaimRoute, KennelClaimPage } from "@/features/provider-home";

export const Route = createFileRoute("/kennel/claim")({
    ssr: kennelClaimRoute.ssr,
    head: kennelClaimRoute.head,
    component: KennelClaimPage,
});
